export enum MutationKey {
  LOGIN = 'LOGIN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  CREATE_NG_WORD = 'CREATE_NG_WORD',
  UPDATE_NG_WORD = 'UPDATE_NG_WORD',
  DELETE_NG_WORD = 'DELETE_NG_WORD',
  TOGGLE_NG_WORD = 'TOGGLE_NG_WORD',
  APPROVE_APPLICATION = 'APPROVE_APPLICATION',
  REJECT_APPLICATION = 'REJECT_APPLICATION',
  CREATE_SERVICE_PACKAGE = 'CREATE_SERVICE_PACKAGE',
  UPDATE_SERVICE_PACKAGE = 'UPDATE_SERVICE_PACKAGE',
  DELETE_SERVICE_PACKAGE = 'DELETE_SERVICE_PACKAGE',
  APPROVE_CATEGORY_REQUEST = 'APPROVE_CATEGORY_REQUEST',
  REJECT_CATEGORY_REQUEST = 'REJECT_CATEGORY_REQUEST',
  UPDATE_USER_ROLE = 'UPDATE_USER_ROLE',
  UPDATE_USER_EMAIL_VERIFIED = 'UPDATE_USER_EMAIL_VERIFIED',
  GRANT_USER_POINTS = 'GRANT_USER_POINTS',
  CREATE_SKILL = 'CREATE_SKILL',
  UPDATE_SKILL = 'UPDATE_SKILL',
  DELETE_SKILL = 'DELETE_SKILL',
  UPLOAD_SKILL_ICON = 'UPLOAD_SKILL_ICON',
  CREATE_SCHOOL = 'CREATE_SCHOOL',
  UPDATE_SCHOOL = 'UPDATE_SCHOOL',
  IMPORT_SCHOOLS_CSV = 'IMPORT_SCHOOLS_CSV',
  SYNC_SCHOOL_MIRRORS = 'SYNC_SCHOOL_MIRRORS',
}
